module.exports = __webpack_public_path__ + "static/media/proupuestas_valor_1.e69d4b1e.png";